// import * as bootstrap from 'bootstrap';
// or, specify which plugins you need:

import * as bootstrap from 'bootstrap';

import "./project.scss";
import 'animate.css';

const htmx = require('htmx.org');
window.htmx = htmx;
import * as hyperscript from 'hyperscript.org';

hyperscript.browserInit();

import jQuery from 'jquery';

const $ = jQuery;
//var _ = require('lodash');

import Dropzone from "dropzone";
import Sortable from 'sortablejs';
import Postmate from 'postmate';

import "./navigation-mobile";
import "./navigation-desktop";
import "./multi-carousel";

import Lightbox from 'bs5-lightbox';
import Swal from 'sweetalert2'

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

$(document).ready(function () {
    const options = {
        keyboard: true,
        size: 'fullscreen'
    };

    document.querySelectorAll('.my-lightbox-toggle').forEach((el) => el.addEventListener('click', (e) => {
        e.preventDefault();
        const lightbox = new Lightbox(el, options);
        lightbox.show();
    }));
});

import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start();

// OWEB-67: phone field with country picker; the library (and its CSS, flags and utils) only loads when a contact form is
// shown. If it cannot load, the plain field stays and the server checks the number as typed.
const phoneInput = (input) => import(/* webpackChunkName: "phone-input" */ './phone-input')
    .then((module) => module.init(input))
    .catch(() => {});

// The contact forms push their phone input here. Cookiebot (auto-blocking) runs this bundle only after the page has
// loaded, later than the forms' own scripts: inputs pushed before that wait in the array.
const queuedPhoneInputs = Array.isArray(window.owebPhoneInputs) ? window.owebPhoneInputs : [];
window.owebPhoneInputs = {push: phoneInput};
queuedPhoneInputs.forEach(phoneInput);

// OWEB-8: the search pages used to keep the last search in the browser ('last-search') for buttons that were never
// shown, without consent. That code is gone; clear what earlier visits left.
try {
    localStorage.removeItem('last-search');
    sessionStorage.removeItem('last-search');
} catch (e) {}

export {bootstrap, htmx, $, Dropzone, Sortable, Swal, Swiper, Postmate};